/* Akkurando 2.0 – 1:1-Batterie-Maßband
   Ablauf: Einmessen (Karte 85,60 × 53,98 mm oder 1-Euro-Münze Ø 23,25 mm) → Bauform → Messen → Ergebnis.
   Grundsätze (Handbuch Kap. 6):
   - Alle Maße in mm, gezeichnet mit ppmm (CSS-Pixel pro mm) aus der Kalibrierung, ohne Rundung.
   - Messflächen sind nicht interaktiv (pointer-events:none): Eine aufgelegte Metallbatterie kann auf
     Touchscreens Berührungen auslösen. Bedienelemente liegen immer außerhalb der Messfläche.
   - Kalibrierung gilt nur für denselben Bildschirm (Größe + devicePixelRatio). Zoom → Hinweis, neu einmessen.
   - Ohne localStorage funktioniert alles für die laufende Sitzung. */
(function () {
  'use strict';
  var root = document.querySelector('[data-akm]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var DATA, EQ = [];
  try { DATA = JSON.parse(root.querySelector('[data-akm-data]').textContent); } catch (e) { return; }
  try { EQ = JSON.parse(root.querySelector('[data-akm-equiv]').textContent); } catch (e) { EQ = []; }

  var dlg = root.querySelector('[data-akm-dialog]');
  var body = dlg.querySelector('[data-akm-body]');
  var stepsEl = dlg.querySelector('[data-akm-steps]');
  var backBtn = dlg.querySelector('[data-akm-back]');
  var zoomEl = dlg.querySelector('[data-akm-zoom]');
  var opener = root.querySelector('[data-akm-open]');
  var hasDialog = typeof dlg.showModal === 'function';
  /* Dialog an <body> hängen: Er darf nicht in einem ausgeblendeten Tab liegen (sonst unsichtbar). */
  document.body.appendChild(dlg);

  var CARD = { w: 85.60, h: 53.98, r: 3.18 };   /* ISO/IEC 7810 ID-1 */
  var COIN = 23.25;                             /* 1-Euro-Münze */
  var OX = 6;                                   /* Abstand der Kartenecke vom Feldrand in px */
  var KEY = 'akk-measure-v1';
  var SNAP = [6.8, 7.9, 9.5, 11.6, 12.5, 16, 20, 24.5];
  var TOL = 0.45;                               /* mm Toleranz beim Durchmesser */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hilfen ---------- */
  function fmt(n, d) { return Number(n).toLocaleString('de-DE', { minimumFractionDigits: d === undefined ? 1 : d, maximumFractionDigits: d === undefined ? 1 : d }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function dpr() { return window.devicePixelRatio || 1; }
  function sig() { var a = screen.width || 0, b = screen.height || 0; return Math.min(a, b) + 'x' + Math.max(a, b) + '@' + Math.round(dpr() * 1000) / 1000; }
  function zoomed() { var vv = window.visualViewport; return !!(vv && Math.abs(vv.scale - 1) > 0.02); }
  function buzz() { if (!reduce && navigator.vibrate) { try { navigator.vibrate(6); } catch (e) {} } }
  function link(code) {
    var t = code.slice(0, 1), v = code.slice(2);
    if (t === 'k') return '/collections/knopfzellen?filter.p.m.custom.battery_size=' + encodeURIComponent(v);
    if (t === 'b') return '/collections/batterien-2?filter.p.m.custom.battery_size=' + encodeURIComponent(v);
    return '/search?type=product&q=' + encodeURIComponent(v);
  }
  function aliases(item) {
    var skip = { MIGNON: 1, MICRO: 1, BABY: 1, MONO: 1, LADY: 1, GELB: 1 }, out = [], seen = {};
    (item.eq || []).forEach(function (id) {
      EQ.forEach(function (e) {
        if (e.id !== id) return;
        (e.a || []).forEach(function (a) {
          var k = String(a).toUpperCase();
          if (skip[k] || seen[k] || item.n.toUpperCase().indexOf(k) > -1) return;
          seen[k] = 1; out.push(a);
        });
      });
    });
    return out.slice(0, 10);
  }

  /* ---------- Kalibrierung speichern/laden ---------- */
  var mem = null;
  function loadCal() {
    var o = mem;
    try { var s = localStorage.getItem(KEY); if (s) o = JSON.parse(s); } catch (e) {}
    if (o && o.sig === sig() && o.ppmm > 1.5 && o.ppmm < 25) return o;
    return null;
  }
  function saveCal(ppmm, method) {
    var o = { ppmm: ppmm, method: method, sig: sig(), t: Date.now() };
    mem = o;
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }
  function guess() { return window.matchMedia && matchMedia('(pointer: coarse)').matches ? 6.0 : 4.0; }

  /* ---------- Zustand ---------- */
  var S = { step: 'cal', hist: [], ppmm: null, method: 'card', calTry: null, dia: 20, cands: [], pick: null, cyl: 5, kind: null };
  var STEPNAME = { cal: 'Schritt 1 von 3 · Einmessen', kind: 'Schritt 2 von 3 · Bauform', coin: 'Schritt 3 von 3 · Messen', thick: 'Schritt 3 von 3 · Dicke', cyl: 'Schritt 3 von 3 · Vergleichen', hg: 'Schritt 3 von 3 · Vergleichen', res: 'Ergebnis' };

  function go(step, push) {
    if (push !== false && S.step !== step) S.hist.push(S.step);
    S.step = step;
    render(true);
  }
  function back() {
    if (!S.hist.length) { close(); return; }
    S.step = S.hist.pop();
    render(true);
  }

  /* ---------- Öffnen / Schließen ---------- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    var cal = loadCal();
    S.hist = []; S.pick = null;
    if (cal) { S.ppmm = cal.ppmm; S.step = 'kind'; } else { S.ppmm = null; S.step = 'cal'; }
    document.documentElement.classList.add('akm-lock');
    if (hasDialog) { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); dlg.classList.add('akm--fallback'); }
    render(false);
  }
  function close() {
    if (hasDialog && dlg.open) dlg.close(); else { dlg.removeAttribute('open'); cleanup(); }
  }
  function cleanup() {
    document.documentElement.classList.remove('akm-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
  }
  dlg.addEventListener('close', cleanup);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); }); /* Klick auf den Hintergrund (Desktop) */
  dlg.querySelector('[data-akm-close]').addEventListener('click', close);
  backBtn.addEventListener('click', back);
  opener.addEventListener('click', open);
  if (!root.hasAttribute('data-akm-noentry')) root.hidden = false;

  /* ---------- Zoom / Bildschirmwechsel überwachen ---------- */
  function checkEnv() {
    var z = zoomed();
    zoomEl.hidden = !z;
    dlg.classList.toggle('is-zoomed', z);
    if (S.ppmm && S.step !== 'cal' && !loadCal()) { /* devicePixelRatio oder Bildschirm hat sich geändert */
      S.ppmm = null; S.hist = []; S.step = 'cal'; render(false, 'Dein Bildschirm hat sich geändert (Zoom oder anderer Monitor). Bitte einmal neu einmessen.');
    }
  }
  if (window.visualViewport) window.visualViewport.addEventListener('resize', checkEnv);
  var rt = 0;
  window.addEventListener('resize', function () {
    if (!dlg.open && !dlg.hasAttribute('open')) return;
    clearTimeout(rt); rt = setTimeout(function () { checkEnv(); if (S.step !== 'cal' || S.ppmm === null) render(false); else render(false); }, 140);
  });

  /* ---------- Gemeinsame Bausteine ---------- */
  function head(title, text) {
    return '<h2 class="akm__h" id="akm-title" tabindex="-1">' + title + '</h2>' + (text ? '<p class="akm__p">' + text + '</p>' : '');
  }
  function ctrl(label) {
    return '<div class="akm-ctrl"><button type="button" class="akm-pm" data-dec aria-label="Kleiner">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
      '<input type="range" class="akm-range" data-range aria-label="' + label + '">' +
      '<button type="button" class="akm-pm" data-inc aria-label="Größer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg></button></div>';
  }
  /* ± mit Gedrückthalten; ruft fn(+1|-1) */
  function bindPM(fn) {
    [['[data-dec]', -1], ['[data-inc]', 1]].forEach(function (p) {
      var b = body.querySelector(p[0]); if (!b) return;
      var t1 = 0, t2 = 0;
      function stop() { clearTimeout(t1); clearInterval(t2); }
      b.addEventListener('pointerdown', function (e) { e.preventDefault(); fn(p[1]); stop(); t1 = setTimeout(function () { t2 = setInterval(function () { fn(p[1]); }, 55); }, 380); });
      ['pointerup', 'pointerleave', 'pointercancel', 'blur'].forEach(function (ev) { b.addEventListener(ev, stop); });
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(p[1]); } });
    });
  }
  function boardSize(el) { var r = el.getBoundingClientRect(); return { w: Math.max(0, r.width), h: Math.max(0, r.height) }; }

  /* ---------- Rendern ---------- */
  function render(anim, notice) {
    stepsEl.textContent = STEPNAME[S.step] || '';
    backBtn.hidden = S.hist.length === 0;
    body.className = 'akm__body akm__body--' + S.step + (anim && !reduce ? ' akm-in' : '');
    ({ cal: rCal, kind: rKind, coin: rCoin, thick: rThick, cyl: rCyl, hg: rHg, res: rRes })[S.step](notice);
    checkEnvLight();
    var h = body.querySelector('.akm__h'); if (h && anim !== false) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }
  function checkEnvLight() { var z = zoomed(); zoomEl.hidden = !z; dlg.classList.toggle('is-zoomed', z); }

  /* Schritt 1: Einmessen */
  function rCal(notice) {
    var card = S.method === 'card';
    body.innerHTML = head('Bildschirm einmessen', (notice ? '<strong>' + esc(notice) + '</strong> ' : '') +
      'Einmal einmessen – danach zeigen wir dir Batterien auf diesem Gerät in echter Größe.') +
      '<div class="akm-seg" role="radiogroup" aria-label="Womit einmessen?">' +
      '<button type="button" role="radio" data-m="card" aria-checked="' + card + '">Karte</button>' +
      '<button type="button" role="radio" data-m="coin" aria-checked="' + !card + '">1-Euro-Münze</button></div>' +
      '<p class="akm__how">' + (card
        ? 'Leg eine Karte im Scheckkartenformat (z. B. Bankkarte) <b data-orient></b> auf, <b>linke obere Ecke in die Ecke</b>. Schieb den Regler, bis die <b>orange Linie</b> genau an der Kartenkante liegt.'
        : 'Leg eine <b>1-Euro-Münze</b> in den Kreis. Schieb den Regler, bis der Ring genau am Münzrand liegt.') + '</p>' +
      '<div class="akm-board' + (card ? ' akm-board--card' : ' akm-board--coin') + '" data-board aria-hidden="true"><svg data-svg></svg>' +
      (card ? '<span class="akm-handle" data-handle title="Ziehen zum Anpassen"></span>' : '') + '</div>' +
      ctrl(card ? 'Kartengröße anpassen' : 'Kreisgröße anpassen') +
      (card ? '<p class="akm-tight" data-tight hidden>Am Anschlag und die Karte ist immer noch größer? Dann ist das Feld zu klein – nimm einfach die <button type="button" class="akm-link" data-tocoin>1-Euro-Münze</button>.</p>' : '') +
      '<div class="akm__actions"><button type="button" class="akm-btn akm-btn--p" data-ok>Passt genau</button></div>';

    body.querySelectorAll('[data-m]').forEach(function (b) {
      b.addEventListener('click', function () { if (S.method !== b.dataset.m) { S.method = b.dataset.m; rCal(); } });
      b.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); S.method = S.method === 'card' ? 'coin' : 'card'; rCal(); body.querySelector('[aria-checked="true"]').focus(); } });
    });

    var board = body.querySelector('[data-board]'), svg = body.querySelector('[data-svg]'), range = body.querySelector('[data-range]'), handle = body.querySelector('[data-handle]'), tight = body.querySelector('[data-tight]');
    var tc = body.querySelector('[data-tocoin]'); if (tc) tc.addEventListener('click', function () { S.method = 'coin'; S.calTry = null; rCal(); });
    var bs = boardSize(board), rot = false, maxP;
    if (card) {
      /* Verglichen wird nur die waagerechte Kante. Quer, wenn die lange Seite (85,6 mm) bei realistischer
         Pixeldichte sicher passt; sonst hochkant (53,98 mm waagerecht) – die Karte darf unten angeschnitten sein. */
      rot = bs.w < CARD.w * Math.max(guess(), S.ppmm || 0, 4.6) + 8;
      maxP = (bs.w - OX - 2) / (rot ? CARD.h : CARD.w);
      var o = body.querySelector('[data-orient]'); if (o) o.textContent = rot ? 'hochkant' : 'quer';
    } else {
      maxP = Math.min(bs.w, bs.h) / (COIN + 4);
    }
    maxP = clamp(maxP, 2.2, 20);
    if (S.calTry === null || S.calTry > maxP) S.calTry = clamp(S.ppmm || guess(), 2, maxP);
    range.min = 200; range.max = Math.floor(maxP * 100); range.step = 1; range.value = Math.round(S.calTry * 100);

    function draw() {
      var p = S.calTry;
      if (card) {
        var W = (rot ? CARD.h : CARD.w) * p, H = (rot ? CARD.w : CARD.h) * p, r = CARD.r * p;
        svg.setAttribute('width', bs.w); svg.setAttribute('height', bs.h); svg.setAttribute('viewBox', '0 0 ' + bs.w + ' ' + bs.h);
        svg.innerHTML =
          '<rect x="' + (OX + 1) + '" y="' + (OX + 1) + '" width="' + (W - 2) + '" height="' + (H - 2) + '" rx="' + r + '" class="akm-fill"/>' +
          '<rect x="' + (OX + 1) + '" y="' + (OX + 1) + '" width="' + (W - 2) + '" height="' + (H - 2) + '" rx="' + r + '" class="akm-line"/>' +
          '<path d="M' + OX + ' ' + (OX + 28) + 'V' + OX + 'H' + (OX + 28) + '" class="akm-corner"/>' +
          '<line x1="' + (OX + W - 1) + '" y1="' + OX + '" x2="' + (OX + W - 1) + '" y2="' + Math.min(OX + H, bs.h) + '" class="akm-edge"/>' +
          '<text x="' + (OX + W / 2) + '" y="' + Math.min(OX + H / 2, bs.h / 2) + '" class="akm-svgtxt" text-anchor="middle" dominant-baseline="middle">Karte hier auflegen</text>';
        if (handle) { handle.style.transform = 'translate(' + (OX + W - 22) + 'px,' + (Math.min(OX + H, bs.h) / 2 - 22) + 'px)'; }
        if (tight) tight.hidden = S.calTry < maxP - 0.03;
        range.setAttribute('aria-valuetext', 'Kartenbreite ' + fmt(W, 0) + ' Pixel');
      } else {
        var D = COIN * p, cx = bs.w / 2, cy = bs.h / 2;
        svg.setAttribute('width', bs.w); svg.setAttribute('height', bs.h); svg.setAttribute('viewBox', '0 0 ' + bs.w + ' ' + bs.h);
        svg.innerHTML = '<circle cx="' + cx + '" cy="' + cy + '" r="' + (D / 2 - 1) + '" class="akm-fill"/>' +
          '<circle cx="' + cx + '" cy="' + cy + '" r="' + (D / 2 - 1) + '" class="akm-line"/>' + ticks(cx, cy, D / 2);
        range.setAttribute('aria-valuetext', 'Kreisdurchmesser ' + fmt(D, 0) + ' Pixel');
      }
    }
    draw();
    range.addEventListener('input', function () { S.calTry = range.value / 100; draw(); });
    bindPM(function (d) { S.calTry = clamp(S.calTry + d * 0.01, 2, maxP); range.value = Math.round(S.calTry * 100); draw(); });

    if (handle) {
      var dragging = false;
      handle.addEventListener('pointerdown', function (e) { dragging = true; handle.setPointerCapture(e.pointerId); e.preventDefault(); });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var r = board.getBoundingClientRect(), x = e.clientX - r.left - OX;
        S.calTry = clamp(x / (rot ? CARD.h : CARD.w), 2, maxP); /* nur die waagerechte Kante zählt */
        range.value = Math.round(S.calTry * 100); draw();
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) { handle.addEventListener(ev, function () { dragging = false; }); });
    }
    body.querySelector('[data-ok]').addEventListener('click', function () {
      S.ppmm = S.calTry; saveCal(S.ppmm, S.method); buzz(); go('kind');
    });
  }
  function ticks(cx, cy, r) {
    var s = '', g = 5, l = 12;
    [[0, -1], [1, 0], [0, 1], [-1, 0]].forEach(function (v) {
      s += '<line x1="' + (cx + v[0] * (r + g)) + '" y1="' + (cy + v[1] * (r + g)) + '" x2="' + (cx + v[0] * (r + g + l)) + '" y2="' + (cy + v[1] * (r + g + l)) + '" class="akm-tick"/>';
    });
    return s;
  }

  /* Schritt 2: Bauform */
  function rKind() {
    body.innerHTML = head('Welche Bauform hat deine Batterie?') +
      '<div class="akm-kinds">' +
      kindBtn('coin', 'Knopfzelle', 'Flach und rund, z. B. CR2032, LR44, Uhrenbatterien', '<circle cx="24" cy="24" r="15"/><path d="M15 24h18"/>') +
      kindBtn('cyl', 'Rundzelle', 'Stabförmig, z. B. AA, AAA, C, D, CR123A, 23A', '<rect x="16" y="9" width="16" height="32" rx="4"/><rect x="21" y="5" width="6" height="4" rx="1"/>') +
      kindBtn('hg', 'Hörgerätebatterie', 'Sehr klein, mit farbiger Schutzfolie', '<circle cx="24" cy="26" r="11"/><rect x="21" y="8" width="6" height="7" rx="1.5"/>') +
      '</div>' +
      '<p class="akm__cal">Bildschirm eingemessen · <button type="button" class="akm-link" data-recal>Neu einmessen</button></p>';
    body.querySelectorAll('[data-kind]').forEach(function (b) {
      b.addEventListener('click', function () { S.kind = b.dataset.kind; go(S.kind); });
    });
    body.querySelector('[data-recal]').addEventListener('click', function () { S.calTry = S.ppmm; go('cal'); });
  }
  function kindBtn(k, t, s, icon) {
    return '<button type="button" class="akm-kind" data-kind="' + k + '"><svg viewBox="0 0 48 48" aria-hidden="true">' + icon + '</svg><span><strong>' + t + '</strong><small>' + s + '</small></span></button>';
  }

  /* Schritt 3a: Knopfzelle – Durchmesser */
  function candidates(d) { return DATA.coin.filter(function (c) { return Math.abs(c.d - d) <= TOL; }); }
  function rCoin() {
    body.innerHTML = head('Knopfzelle messen', 'Leg die Batterie flach in den Kreis und schieb den Regler, bis der Ring genau am Rand liegt.') +
      '<div class="akm-board akm-board--coin" data-board aria-hidden="true"><svg data-svg></svg></div>' +
      '<p class="akm-read" data-read aria-live="polite"></p>' +
      ctrl('Durchmesser in Millimetern') +
      '<div class="akm-cands" data-cands aria-live="polite"></div>' +
      '<div class="akm__actions"><button type="button" class="akm-btn akm-btn--p" data-ok>Weiter</button></div>';
    var board = body.querySelector('[data-board]'), svg = body.querySelector('[data-svg]'), range = body.querySelector('[data-range]');
    var read = body.querySelector('[data-read]'), cands = body.querySelector('[data-cands]'), ok = body.querySelector('[data-ok]');
    var bs = boardSize(board), maxD = Math.min(26, (Math.min(bs.w, bs.h) - 40) / S.ppmm);
    range.min = 50; range.max = Math.floor(maxD * 10); range.step = 1;
    S.dia = clamp(S.dia, 5, maxD); range.value = Math.round(S.dia * 10);
    var lastSnap = null;
    function draw() {
      var D = S.dia * S.ppmm, cx = bs.w / 2, cy = bs.h / 2;
      svg.setAttribute('width', bs.w); svg.setAttribute('height', bs.h); svg.setAttribute('viewBox', '0 0 ' + bs.w + ' ' + bs.h);
      svg.innerHTML = '<circle cx="' + cx + '" cy="' + cy + '" r="' + Math.max(1, D / 2 - 1) + '" class="akm-fill"/><circle cx="' + cx + '" cy="' + cy + '" r="' + Math.max(1, D / 2 - 1) + '" class="akm-line"/>' + ticks(cx, cy, D / 2);
      read.innerHTML = '<span>Ø</span> ' + fmt(S.dia) + ' <span>mm</span>';
      range.setAttribute('aria-valuetext', 'Durchmesser ' + fmt(S.dia) + ' Millimeter');
      S.cands = candidates(S.dia);
      if (S.cands.length) {
        cands.innerHTML = '<p>Passt zu Ø ' + fmt(S.cands[0].d) + ' mm:</p><ul>' + S.cands.map(function (c) { return '<li>' + esc(c.n) + '</li>'; }).join('') + '</ul>';
        ok.disabled = false; ok.textContent = S.cands.length > 1 ? 'Weiter: Dicke prüfen' : 'Weiter';
      } else {
        cands.innerHTML = '<p class="akm-none">Bei ' + fmt(S.dia) + ' mm gibt es keine gängige Knopfzelle. Schieb den Ring genau an den Rand – oder lies die Bezeichnung auf der Batterie.</p>';
        ok.disabled = true; ok.textContent = 'Weiter';
      }
    }
    function snapTo(v) {
      for (var i = 0; i < SNAP.length; i++) { if (Math.abs(v - SNAP[i]) <= 0.2) { if (lastSnap !== SNAP[i]) { lastSnap = SNAP[i]; buzz(); read.classList.remove('is-snap'); void read.offsetWidth; read.classList.add('is-snap'); } return SNAP[i]; } }
      lastSnap = null; return v;
    }
    draw();
    range.addEventListener('input', function () { S.dia = snapTo(range.value / 10); draw(); });
    range.addEventListener('change', function () { range.value = Math.round(S.dia * 10); });
    bindPM(function (d) { S.dia = clamp(Math.round((S.dia + d * 0.1) * 10) / 10, 5, maxD); range.value = Math.round(S.dia * 10); lastSnap = null; draw(); });
    ok.addEventListener('click', function () {
      if (!S.cands.length) return;
      if (S.cands.length === 1) { S.pick = S.cands[0]; go('res'); } else go('thick');
    });
  }

  /* Schritt 3b: Knopfzelle – Dicke */
  function rThick() {
    var list = S.cands.slice().sort(function (a, b) { return b.h - a.h; });
    var code = list[0].id.indexOf('CR') === 0 ? 'Steht eine Zahl wie „' + list[0].id.slice(2) + '“ drauf? Die ersten Ziffern sind der Durchmesser, die letzten die Dicke in Zehntel-Millimetern.' : 'Die Bezeichnung steht meist klein auf der flachen Seite.';
    body.innerHTML = head('Wie dick ist sie?', 'Stell die Batterie hochkant neben die Balken (echte Größe). Welcher ist genauso dick? ' + code) +
      '<div class="akm-thick" data-thick></div>';
    var box = body.querySelector('[data-thick]');
    box.innerHTML = list.map(function (c) {
      var w = c.d * S.ppmm, h = c.h * S.ppmm;
      return '<div class="akm-trow"><div class="akm-tbar" aria-hidden="true"><svg width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '"><rect x="0.5" y="0.5" width="' + (w - 1) + '" height="' + (h - 1) + '" rx="' + Math.min(h / 3, 2) + '" class="akm-fill akm-fill--solid"/></svg></div>' +
        '<button type="button" class="akm-choose" data-id="' + c.id + '"><strong>' + esc(c.n) + '</strong><span>' + fmt(c.h) + ' mm dick</span></button></div>';
    }).join('');
    box.querySelectorAll('[data-id]').forEach(function (b) {
      b.addEventListener('click', function () { S.pick = S.cands.filter(function (c) { return c.id === b.dataset.id; })[0]; go('res'); });
    });
  }

  /* Schritt 3c: Rundzelle */
  function rCyl() {
    var L = DATA.cyl;
    S.cyl = clamp(S.cyl, 0, L.length - 1);
    body.innerHTML = head('Rundzelle vergleichen', 'Leg die Batterie auf die Zeichnung – Länge und Breite müssen genau passen.') +
      '<div class="akm-chips" data-chips>' + L.map(function (c, i) { return '<button type="button" class="akm-chip" data-i="' + i + '" aria-pressed="false">' + esc(c.n.split(' ·')[0]) + '</button>'; }).join('') + '</div>' +
      '<div class="akm-board akm-board--cyl" data-board aria-hidden="true"><svg data-svg></svg></div>' +
      '<p class="akm-warn" data-warn hidden></p>' +
      '<div class="akm-cylnav"><button type="button" class="akm-pm" data-prev aria-label="Kleinere Größe"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<p class="akm-cylread" data-read aria-live="polite"></p>' +
      '<button type="button" class="akm-pm" data-next aria-label="Größere Größe"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button></div>' +
      '<div class="akm__actions"><button type="button" class="akm-btn akm-btn--p" data-ok></button></div>';
    var board = body.querySelector('[data-board]'), svg = body.querySelector('[data-svg]'), read = body.querySelector('[data-read]');
    var warn = body.querySelector('[data-warn]'), ok = body.querySelector('[data-ok]'), chips = body.querySelectorAll('[data-i]');
    function draw() {
      var c = L[S.cyl], bs = boardSize(board), p = S.ppmm;
      var D = c.d * p, H = c.h * p, nubD = Math.max(c.d * 0.36, 3) * p, nubH = Math.min(1.2, c.h * 0.04) * p;
      var vertical = H + 8 <= bs.h, horizontal = !vertical && H + 4 <= bs.w && D + 4 <= bs.h;
      warn.hidden = vertical || horizontal;
      warn.textContent = 'Der Bildschirm ist für diese Größe zu klein. Dreh dein Handy quer oder nutze einen größeren Bildschirm.';
      svg.setAttribute('width', bs.w); svg.setAttribute('height', bs.h); svg.setAttribute('viewBox', '0 0 ' + bs.w + ' ' + bs.h);
      var g;
      if (horizontal) {
        var x0 = (bs.w - H) / 2, y0 = (bs.h - D) / 2;
        g = '<rect x="' + (x0 + H - nubH) + '" y="' + (bs.h - nubD) / 2 + '" width="' + nubH + '" height="' + nubD + '" rx="' + nubH / 3 + '" class="akm-fill akm-fill--solid"/>' +
          '<rect x="' + (x0 + 0.5) + '" y="' + (y0 + 0.5) + '" width="' + (H - nubH - 1) + '" height="' + (D - 1) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-fill"/>' +
          '<rect x="' + (x0 + 0.5) + '" y="' + (y0 + 0.5) + '" width="' + (H - nubH - 1) + '" height="' + (D - 1) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-line"/>';
      } else {
        var x1 = (bs.w - D) / 2, y1 = Math.max(4, (bs.h - H) / 2);
        g = '<rect x="' + (bs.w - nubD) / 2 + '" y="' + y1 + '" width="' + nubD + '" height="' + (nubH + 1) + '" rx="' + nubH / 3 + '" class="akm-fill akm-fill--solid"/>' +
          '<rect x="' + (x1 + 0.5) + '" y="' + (y1 + nubH + 0.5) + '" width="' + (D - 1) + '" height="' + (H - nubH - 1) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-fill"/>' +
          '<rect x="' + (x1 + 0.5) + '" y="' + (y1 + nubH + 0.5) + '" width="' + (D - 1) + '" height="' + (H - nubH - 1) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-line"/>';
      }
      svg.innerHTML = g;
      read.innerHTML = '<strong>' + esc(c.n) + '</strong><span>Ø ' + fmt(c.d) + ' × ' + fmt(c.h) + ' mm</span>';
      ok.textContent = 'Das ist meine: ' + c.n.split(' ·')[0];
      chips.forEach(function (b, i) { b.setAttribute('aria-pressed', i === S.cyl ? 'true' : 'false'); if (i === S.cyl && b.scrollIntoView) { try { b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) {} } });
      body.querySelector('[data-prev]').disabled = S.cyl === 0;
      body.querySelector('[data-next]').disabled = S.cyl === L.length - 1;
    }
    draw();
    chips.forEach(function (b) { b.addEventListener('click', function () { S.cyl = +b.dataset.i; draw(); }); });
    body.querySelector('[data-prev]').addEventListener('click', function () { if (S.cyl > 0) { S.cyl--; draw(); } });
    body.querySelector('[data-next]').addEventListener('click', function () { if (S.cyl < L.length - 1) { S.cyl++; draw(); } });
    ok.addEventListener('click', function () { S.pick = L[S.cyl]; go('res'); });
  }

  /* Schritt 3d: Hörgerätebatterie */
  function rHg() {
    body.innerHTML = head('Hörgerätebatterie vergleichen', 'Leg die Batterie auf die Kreise (echte Größe) und achte auf die Farbe der Schutzfolie – sie verrät die Größe sofort.') +
      '<div class="akm-hg">' + DATA.hg.map(function (c) {
        var D = c.d * S.ppmm;
        return '<div class="akm-hgi"><div class="akm-hgd" aria-hidden="true"><svg width="' + (D + 2) + '" height="' + (D + 2) + '" viewBox="-1 -1 ' + (D + 2) + ' ' + (D + 2) + '"><circle cx="' + D / 2 + '" cy="' + D / 2 + '" r="' + (D / 2 - 0.5) + '" class="akm-fill akm-line"/></svg></div>' +
          '<button type="button" class="akm-choose" data-id="' + c.id + '"><i style="background:' + c.c + '"></i><strong>' + c.n.replace('Hörgerätebatterie ', 'Größe ') + '</strong><span>' + c.cn + ' · Ø ' + fmt(c.d) + ' mm</span></button></div>';
      }).join('') + '</div>';
    body.querySelectorAll('[data-id]').forEach(function (b) {
      b.addEventListener('click', function () { S.pick = DATA.hg.filter(function (c) { return c.id === b.dataset.id; })[0]; go('res'); });
    });
  }

  /* Ergebnis */
  function rRes() {
    var c = S.pick; if (!c) { go('kind', false); return; }
    var multi = c.l.length > 1, al = aliases(c);
    body.innerHTML = head((multi ? 'Das ist eine ' : 'Das ist eine ') + esc(c.n)) +
      '<div class="akm-res">' +
      '<div class="akm-board akm-board--res" data-board aria-hidden="true" style="min-height:' + Math.ceil(c.d * S.ppmm + 58) + 'px"><svg data-svg></svg><span class="akm-restag">Echte Größe – zur Kontrolle auflegen</span></div>' +
      '<dl class="akm-dl"><div><dt>Größe</dt><dd>Ø ' + fmt(c.d) + ' × ' + fmt(c.h) + ' mm</dd></div><div><dt>Art</dt><dd>' + esc(c.v) + '</dd></div>' +
      (c.cn ? '<div><dt>Farbe der Folie</dt><dd>' + esc(c.cn) + '</dd></div>' : '') +
      (al.length ? '<div><dt>Auch bekannt als</dt><dd>' + al.map(esc).join(', ') + '</dd></div>' : '') + '</dl>' +
      (multi ? '<p class="akm__note">Diese Größen sind gleich groß, unterscheiden sich aber im Material. Steht auf deiner alten Batterie „SR“ oder eine dreistellige Zahl (z. B. 357), nimm die Silberoxid-Variante – sie ist für Uhren gedacht.</p>' : '') +
      '</div>' +
      '<div class="akm__actions akm__actions--res">' + c.l.map(function (l, i) { return '<a class="akm-btn ' + (i ? 'akm-btn--s' : 'akm-btn--p') + '" href="' + link(l[1]) + '">' + esc(l[0]) + '</a>'; }).join('') +
      '<button type="button" class="akm-btn akm-btn--t" data-again>Nochmal messen</button></div>';
    body.querySelector('[data-again]').addEventListener('click', function () { S.hist = []; S.pick = null; go('kind', false); });
    /* Kontrollzeichnung in echter Größe: Knopfzellen von oben, Rundzellen liegend */
    var board = body.querySelector('[data-board]'), svg = body.querySelector('[data-svg]'), bs = boardSize(board), p = S.ppmm, g, T = 36; /* T = Platz für die Beschriftung oben */
    svg.setAttribute('width', bs.w); svg.setAttribute('height', bs.h); svg.setAttribute('viewBox', '0 0 ' + bs.w + ' ' + bs.h);
    if (c.h > c.d) { var L = c.h * p, D = c.d * p, x0 = (bs.w - L) / 2, y0 = T + (bs.h - T - D) / 2;
      g = '<rect x="' + (x0 + 1) + '" y="' + (y0 + 1) + '" width="' + (L - 2) + '" height="' + (D - 2) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-fill"/><rect x="' + (x0 + 1) + '" y="' + (y0 + 1) + '" width="' + (L - 2) + '" height="' + (D - 2) + '" rx="' + Math.min(D * 0.12, 3 * p) + '" class="akm-line"/>';
    } else { var R = c.d * p / 2, cx = bs.w / 2, cy = T + (bs.h - T) / 2;
      g = '<circle cx="' + cx + '" cy="' + cy + '" r="' + (R - 1) + '" class="akm-fill"/><circle cx="' + cx + '" cy="' + cy + '" r="' + (R - 1) + '" class="akm-line"/>'; }
    svg.innerHTML = g;
    if (Math.max(c.h, c.d) * p + 8 > bs.w || c.d * p + T > bs.h) board.hidden = true; /* passt nicht in echter Größe → keine abgeschnittene Zeichnung */
    buzz();
  }

  /* Einstieg auch über Links mit #messen */
  if (location.hash === '#messen') setTimeout(open, 300);
  /* Links auf „#messen“ (Hauptmenü, Produktseite …) öffnen das Maßband auf der aktuellen Seite, wenn es hier eingebunden ist.
     Seiten ohne Maßband laden die Startseite, dann greift die Zeile oben. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#messen"]');
    if (a && a.hash === '#messen' && a.hostname === location.hostname) { e.preventDefault(); setTimeout(open, 0); }
  });
  window.addEventListener('hashchange', function () { if (location.hash === '#messen' && !dlg.open) open(); });
})();
